import { Badge } from '@/components/ui/badge';
import { Vertrag } from '@/domain/vertraege/shared/types/vertrag';

export function VertragsInfo({ vertrag }: { vertrag: Vertrag }) {
  return (
    <div className="w-full flex flex-col gap-2">
      <h5 className="font-bold">W-{vertrag.id}</h5>
      <div className="flex flex-row gap-2">
        <Badge
          variant="secondary"
          className="font-semibold text-neutrals-800 bg-[#E5E7EB]">
          {'K-' + vertrag.kundennummer.toString()}
        </Badge>
        <span>{vertrag.unternehmensname}</span>
      </div>
    </div>
  );
}
